import { useEffect, useRef, useState } from "react";
import { sortOptions } from "@/mocks/products";

interface SortDropdownProps {
  value: string;
  onChange: (id: string) => void;
}

export default function SortDropdown({ value, onChange }: SortDropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const active = sortOptions.find((option) => option.id === value) ?? sortOptions[0];

  return (
    <div ref={ref} className="relative flex items-center gap-2">
      <span className="hidden text-xs text-foreground-500 sm:inline">Ordenar por:</span>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex h-9 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400"
      >
        {active.label}
        <i className={`ri-arrow-down-s-line text-base transition-transform ${open ? "rotate-180" : ""}`}></i>
      </button>
      {open && (
        <div className="absolute right-0 top-full z-30 mt-1 w-48 overflow-hidden rounded-md border border-background-200 bg-background-50 py-1.5 shadow-lg">
          {sortOptions.map((option) => (
            <button
              key={option.id}
              type="button"
              onClick={() => {
                onChange(option.id);
                setOpen(false);
              }}
              className={`block w-full px-4 py-2 text-left text-sm transition-colors hover:bg-background-100 ${
                option.id === value ? "font-medium text-primary-700" : "text-foreground-700"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}